import React from "react";
import { formatDate } from "../../../utils/utils";

function TeamMemberships({ teamResult }) {

  return (
    <div className="mb-4 mt-4">
      <h2 className="text-xl font-bold mb-2">Team Memberships</h2>
      {teamResult.map((membership, index) => (
        <div key={index} className="mb-2">
             {membership.club.logo ? (
                        <img
                          src={membership.club.logo.urls["60x60"]}
                          alt={membership.club.name}
                          className="w-10 h-10"
                        />) : null}
          <p><strong>Club:</strong> {membership.club?.name}</p>
          <p><strong>Date:</strong> {formatDate(membership.startDate)} - {membership.endDate ? formatDate(membership.endDate) : "Present"}</p>
        </div>
      ))}
    </div>
  );
}

export default TeamMemberships;
